module.exports = __webpack_public_path__ + "static/img/press.b34fd6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/thumbs/press.png
// module id = GrRr
// module chunks = 0